import { render } from "./YandexCaptcha.vue?vue&type=template&id=86820d40&ts=true"
import script from "./YandexCaptcha.vue?vue&type=script&lang=ts"
export * from "./YandexCaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__